import axios from 'axios';
import { Setting } from '../types/constant/PagesPropsType';
import { CUSTOMER_API_URL } from '../constants';
import { BillingPolicyIntervalType, SubscriptionApiType } from '../types/api/SubscriptionApiType';

export type Billing = {
  billingPolicyIntervalCount: number;
  billingPolicyInterval: BillingPolicyIntervalType;
};

export const useUpdateSubscriptionLinePlan = () => {
  /**
   * 定期購買の決済周期を更新する
   *
   * @param setting
   * @param subscription
   * @param changeDeliveryDateModal
   * @param success
   * @param failed
   * @param completion
   */
  const updateSubscriptionLinePlan = (
    setting: Setting,
    subscription: SubscriptionApiType,
    changeInterval: {
      billingPolicyIntervalCount: number;
      billingPolicyInterval: BillingPolicyIntervalType;
    },
    success: () => void,
    failed: () => void,
    completion: () => void
  ) => {
    const data: {
      subscriptionContractId: string;
      billingPolicyInterval: string;
      billingPolicyIntervalCount: number;
    } = {
      subscriptionContractId: subscription.subscriptionContractId,
      billingPolicyInterval: changeInterval.billingPolicyInterval,
      billingPolicyIntervalCount: changeInterval.billingPolicyIntervalCount,
    };

    axios
      .post(
        `${CUSTOMER_API_URL}?action=updateSubscriptionLinePlanV2`,
        { ...data },
        { headers: { Authorization: setting.token } }
      )
      .then((response) => {
        success();
      })
      .catch((e) => {
        console.log(e);
        failed();
      })
      .finally(() => completion());
  };

  /**
   * 定期購買の決済周期を更新する
   *
   * @param token
   * @param subscriptionContractId
   * @param success
   * @param failed
   * @param completion
   */
  const getChangeableCycles = async (
    token: string,
    subscriptionContractId: string
  ): Promise<Billing[] | null> => {
    try {
      const response = await axios.post(
        `${CUSTOMER_API_URL}?action=getChangeableCycles`,
        { subscriptionContractId },
        { headers: { Authorization: token } }
      );

      return response.data;
    } catch (e) {
      // APIエラー時はnullを返す（元のロジックを維持）
      return null;
    }
  };

  return {
    updateSubscriptionLinePlan,
    getChangeableCycles,
  };
};
